import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import PropTypes from 'prop-types';
// HOCs
import withTitle from 'hocs/WithTitle';
// Core components
import Box from 'components/core/Box';
import Card from 'components/core/Card';
// Custom
import { ContainedButton } from 'components/core/Button';
import CpmClientTemplate from 'components/templates/apps/CpmClientTemplate';
import { navigateToContactUs } from 'cpmMore/navigation';

const Error404 = ({ withoutTemplate }) => {
  const content = (
    <Box type="defaultBackground" style={{ maxWidth: 1000, margin: '0 auto' }}>
      <div className="d-flex justify-content-center">
        <div className="row w-100">
          <div className="col-12">
            <Card>
              {/* 404 */}
              <div className="row text-center">
                <div className="col-12">
                  <span className="error404FirstNumber">4</span>
                  <span className="error404SecondNumber">0</span>
                  <span className="error404ThirdNumber">4</span>
                </div>
                {/* Text */}
                <div className="col-12 mb-3 error404Title">
                  <LocalizedMessage id="info.error404" />
                </div>
                {/* Text */}
                <div className="col-12 mb-3 error404TextBold">
                  <LocalizedMessage id="info.error404Retry" />
                </div>
                {/* Buttons */}
                <div className="col-12 mt-3">
                  <ContainedButton label={<LocalizedMessage id="button.contactUs" />} color="secondary" onClick={navigateToContactUs} />
                </div>
                {/* Text */}
                <div className="col-12 mt-3 error404Text">
                  <LocalizedMessage id="info.error404ContactUs" />
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </Box>
  );

  return withoutTemplate ? content : <CpmClientTemplate>{content}</CpmClientTemplate>;
};

Error404.propTypes = {
  withoutTemplate: PropTypes.bool,
};

Error404.defaultProps = {
  withoutTemplate: false,
};

module.exports = withTitle('pageTitle.404')(Error404);



// WEBPACK FOOTER //
// ./routes/404/components/cpm_client/404.js